import React from "react";
import { Alert, Table } from "antd";
import { useQuery } from "@apollo/client";
import { useTranslation } from "react-i18next";
import moment from "moment";
// graphql
import GET_VNPAY_ORDERS from "graphql/queries/GetVnpayOrders";
// styling
import { SectionHeader } from "./MyBillingsStyling";

const columns = [
  {
    title: "Order ID",
    dataIndex: "orderId",
    key: "orderId",
  },
  {
    title: "Order Type",
    dataIndex: "orderType",
    key: "orderType",
  },
  {
    title: "Description",
    dataIndex: "description",
    key: "description",
  },
  {
    title: "Amount",
    dataIndex: "amount",
    key: "amount",
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
  },
  {
    title: "Currency Code",
    dataIndex: "currencyCode",
    key: "currencyCode",
  },
  {
    title: "Locale",
    dataIndex: "locale",
    key: "locale",
  },
  {
    title: "Create Date",
    dataIndex: "createDate",
    key: "createDate",
    render: (date: Date) => moment(new Date(date)).format("LL"),
  },
];

const VnpayOrders = () => {
  const { t } = useTranslation("my_billing");
  const { data, error, loading } = useQuery(GET_VNPAY_ORDERS, {
    fetchPolicy: "network-only",
  });

  if (loading) {
    return <Alert type="info" message={t("Loading invoices...")} />;
  }

  if (error) {
    return (
      <Alert
        type="error"
        message={t(
          "Error loading invoices. Please check your internet or let us know if this keeps happening."
        )}
      />
    );
  }

  const paginationConfig = {
    pageSize: 20,
    total: data.vnpayOrders.length,
  };

  return (
    <div>
      <SectionHeader>{t("PAYMENT HISTORIES")}</SectionHeader>
      <Table
        columns={columns}
        dataSource={data.vnpayOrders}
        pagination={paginationConfig}
        rowKey="id"
      />
    </div>
  );
};

export default VnpayOrders;
